import { Injectable } from '@angular/core';
import { HttpServiceBundle } from '@app/core/services/base/http-service-bundle.service';
import { BaseHttpWithBundleService } from '@app/core/services/base/base-service-with-bundle.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BackendUriUnits } from '@app/core/services/base/backend-uri-units';
import { DRResponse } from '@app/shared/models/response';

@Injectable({ providedIn: 'root' })
export class DecisionService extends BaseHttpWithBundleService {

    constructor(httpServiceBundle: HttpServiceBundle) {
        super(httpServiceBundle);
        this.uri += `/${BackendUriUnits.DECISIONS}`;
    }

    public query(): Observable<string[]> {
        return this.http.get<DRResponse<string[]>>(this.uri)
                        .pipe(map(result => result.data));
    }
}
